import React, { useState } from 'react';
import AllFilterCategory from './AllFilterCategory/AllFilterCategory';
import { ReactComponent as Chevron } from '../../../../../../../assets/icons/chevron.svg';
import { ReactComponent as AmenitiesIcon } from '../../../../../../../assets/icons/redesign_amenities_icon.svg';
import data from './allFilter.json';
import styles from './AllFilter.module.scss';
import { useResultListContext } from 'common/contexts/ResultListContext';
import {useLocation} from 'react-router-dom';
import { switches } from 'common/pages/SearchResultsRedesign/ResultsList.utils';

interface Props {
  fetchData: Function,
}

type CategoryFilter = {
  [key: number]: string;
};

type AllFilters = {
  [category: string]: CategoryFilter;
};

const typedData: AllFilters = data;

const AllFilter: React.FC<Props> = ({
  fetchData,
}) => {
  const [showApplyButton, setShowApplyButton] = useState(false);
  const [isFilterVisible, setIsFilterVisible] = useState(true);
  const location = useLocation();

  const {
    setActiveFilters,
    currentDuration,
    currentLocation,
    workspaceType,
    budgetValues,
    sortBy,
    amenitiesPayload,
    setAmenitiesPayload,
    setCurrentAmenities,
  } = useResultListContext();

  const handleFilterChange = (filterId: string) => {
    const searchParams = new URLSearchParams(location.search);
    const amenitiesFilter = searchParams.get('amenities')
    ?.replace(/^,+/g, '') 
    .replace(/,+/g, ',')
    .replace(/,$/g, '')
    .replace(/^undefined,|,undefined$|,undefined,/g, '')
    .replace(/NaN|NaN,|,NaN$|,NaN,/g, '') || '';
    const isRemove = amenitiesFilter.split(',').includes(filterId);
    const currentAmenities = isRemove ? `&amenities=${amenitiesFilter.split(',').filter((el) => el != filterId).join(',')}` : `&amenities=${amenitiesFilter.length > 0 ? amenitiesFilter + ',' : ''}${filterId}`;
    setAmenitiesPayload((prev:string) => {
      const isRemoveFromPayload = amenitiesPayload.length > 0 ? amenitiesPayload?.split('=')[1]?.split(',').includes(filterId) : false;
      const updatedAmenities = amenitiesPayload.length > 0 ? isRemoveFromPayload ? `&amenities=${prev.split('=')[1].split(',').filter((el) => el != filterId).join(',')}` : `${prev},${filterId}` : currentAmenities;
      setShowApplyButton(true);

      return updatedAmenities;
    });

    setActiveFilters((prevActiveFilters:any) => {
      const updatedFilters = { ...prevActiveFilters };
      updatedFilters[filterId] = !updatedFilters[filterId];

      return updatedFilters;
    })
  };

  const applyAmenities = (e:any) => {
    e.stopPropagation();
    // @ts-ignore
    const currentResources = Object.entries(workspaceType).filter((el) => el[1] == true).map(item => switches[item[0]]);
    setShowApplyButton(false);

    fetchData(
      currentLocation.lat,
      currentLocation.lng,
      currentLocation.rad,
      10,
      0,
      currentResources,
      amenitiesPayload,
      currentDuration,
      budgetValues,
      sortBy,
    );

    setCurrentAmenities(amenitiesPayload);
    setAmenitiesPayload('');
  }

  const categories = Object.keys(data);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevIsFilterVisible) => !prevIsFilterVisible);
  };

  React.useEffect(() => {
    return () => {
      setAmenitiesPayload('');

      // clear chosen filters if we close popup
      const searchParams = new URLSearchParams(location.search);
      const amenitiesFilter = searchParams.get('amenities')?.replace(/^,+/g, '').replace(/,+/g, ',').replace(/,$/g, '').replace(/^undefined,|,undefined$|,undefined,/g, '').replace(/NaN|NaN,|,NaN$|,NaN,/g, '').split(',') || [''];

      setActiveFilters((prev:any) => {
          const updatedFilters:any = {} ;

          for (const key in prev) {
            updatedFilters[key] = false;
          }

          for (let i = 0; i < amenitiesFilter.length; i++) {
            updatedFilters[amenitiesFilter[i]] = true;
          }
          return updatedFilters;
        })
      };
  }, []);

  return (
    <button className={styles.container} onClick={toggleFilterVisibility} type="button">
      <div className={styles.heading}>
        <div className={styles.toggle}>
          <AmenitiesIcon />
          Amenities
        </div>
        {amenitiesPayload.length > 0 && showApplyButton && <button className={styles.apply} onClick={(e) => applyAmenities(e)}>Apply</button>}
        <Chevron style={{ transform: !isFilterVisible ? 'rotate(270deg)' : 'none' }} />
      </div>
      {isFilterVisible && (
          <div
            className={styles.container__filters}
            onClick={(e) => {
              e.stopPropagation();
            }}
            style={{ display: isFilterVisible ? 'block' : 'none' }}
          >
            {categories.map((category) => (
              <AllFilterCategory
                key={category}
                category={category}
                filters={typedData[category]}
                onFilterChange={handleFilterChange}
              />
            ))}
        </div>
      )}
    </button>
  );
};

export default AllFilter;
